// Claude: SellerRenewModal — plan change, payment record (no credits) 25-Apr-2026
import { Box, Button, Flex, Input, Text } from "@chakra-ui/react";
import { Modal, Select } from "antd";
import React, { useEffect, useState } from "react";

export interface SellerRenewData {
  subscriptionPlanId: string;
  date: string;
  paymentReference: string;
  planName: string;
  paidAmount: string;
}

interface Props {
  isOpen: boolean;
  onClose: () => void;
  sellerId: string;
  plansData: any[];
  onConfirm: (data: SellerRenewData) => Promise<void>;
  loading?: boolean;
  initialPlanId?: string;
}

const SellerRenewModal = ({ isOpen, onClose, sellerId, plansData, onConfirm, loading, initialPlanId }: Props) => {
  const [formData, setFormData] = useState<SellerRenewData>({
    subscriptionPlanId: "", date: "", paymentReference: "",
    planName: "", paidAmount: "",
  });

  useEffect(() => {
    if (isOpen) {
      if (initialPlanId) {
        const plan = plansData.find((p: any) => p._id === initialPlanId);
        setFormData({
          subscriptionPlanId: initialPlanId,
          date: "", paymentReference: "",
          planName: plan?.planName ?? "",
          paidAmount: "",
        });
      } else {
        setFormData({ subscriptionPlanId: "", date: "", paymentReference: "", planName: "", paidAmount: "" });
      }
    }
  }, [isOpen, initialPlanId]);

  const selectedPlan = plansData.find((p: any) => p._id === formData.subscriptionPlanId);
  const currency = selectedPlan?.currency ?? "";

  const set = (key: keyof SellerRenewData) => (e: React.ChangeEvent<HTMLInputElement>) =>
    setFormData(p => ({ ...p, [key]: e.target.value }));

  const handlePlanChange = (v: string) => {
    const plan = plansData.find((p: any) => p._id === v);
    setFormData(p => ({
      ...p,
      subscriptionPlanId: v ?? "",
      planName: plan?.planName ?? "",
    }));
  };

  return (
    <Modal title="Subscription" open={isOpen} onCancel={onClose} footer={null} destroyOnClose width={480}>
      <Box pt={2}>
        <Box mb={3}>
          <Text fontSize="xs" mb={1} fontWeight="medium">Plan</Text>
          <Select
            style={{ width: "100%", fontSize: "12px" }}
            value={formData.subscriptionPlanId || undefined}
            onChange={handlePlanChange}
            options={plansData.map((p: any) => ({ label: p.planName, value: p._id }))}
            allowClear
            placeholder="Select plan"
          />
        </Box>

        <Flex gap={2} flexWrap="wrap" mb={3}>
          <Box flex={1} minW="120px">
            <Text fontSize="xs" mb={1}>Date</Text>
            <Input type="date" height="30px" fontSize="xs" value={formData.date} onChange={set("date")} />
          </Box>
          <Box flex={2} minW="160px">
            <Text fontSize="xs" mb={1}>Payment Reference</Text>
            <Input height="30px" fontSize="xs" placeholder="Ref" value={formData.paymentReference} onChange={set("paymentReference")} />
          </Box>
        </Flex>

        <Box mb={4}>
          <Text fontSize="xs" mb={1}>Paid Amount {currency ? `(${currency})` : ""}</Text>
          <Input height="30px" fontSize="xs" placeholder="0" value={formData.paidAmount} onChange={set("paidAmount")} />
        </Box>

        <Flex gap={2} justifyContent="flex-end">
          <Button h="30px" fontSize="xs" variant="outline" onClick={onClose}>Cancel</Button>
          <Button h="30px" fontSize="xs" bg="#0E122F" color="white" _hover={{ bg: "#2E7D32" }} isLoading={loading} onClick={() => onConfirm(formData)}>
            Confirm
          </Button>
        </Flex>
      </Box>
    </Modal>
  );
};

export default SellerRenewModal;
